import {MithrilComponent} from '@bitstillery/mithril'
import {Progress} from '@bitstillery/common/components'
import {classes} from '@bitstillery/common/lib/utils'
import m from '@bitstillery/mithril'
import type {Content} from 'tippy.js'

interface RankingAttrs {
    model: {
        rank: number | null | undefined
        tip: Content
        total: number | null | undefined
    }
    type?: string
}

export class Ranking extends MithrilComponent<RankingAttrs> {
    ranking(model: RankingAttrs['model']) {
        if (model.total === 1) {
            return 'success'
        }

        if (model.rank === 1) {
            return 'success'
        } else if (Number(model.rank) / Number(model.total) <= 0.5) {
            return 'info'
        } else if (Number(model.rank) < Number(model.total)) {
            return 'warning'
        }

        return 'danger'
    }

    view(vnode: m.Vnode<RankingAttrs>) {
        return (
            <div
                className={classes(
                    'c-ranking',
                    vnode.attrs.type ? `type-${vnode.attrs.type}` : 'type-default',
                    this.ranking(vnode.attrs.model),
                )}
            >
                <Progress
                    percentage={(() => {
                        const rank = Number(vnode.attrs.model.rank) - 1
                        const total = Number(vnode.attrs.model.total) - 1
                        return 100 - (rank / total) * 100
                    })()}
                    tip={vnode.attrs.model.tip}
                    type={vnode.attrs.type ? vnode.attrs.type : this.ranking(vnode.attrs.model)}
                />
                <span>
                    {vnode.attrs.model.rank} / {vnode.attrs.model.total}
                </span>
            </div>
        )
    }
}
